import { useState, useEffect } from "react";
import { DateTime } from "luxon";
import ReactLoading from "react-loading";
import {
  Container,
  Prevision,
  Author,
  TasksManager,
  Status,
  ProgressionBar,
  Progression,
  Description,
  Date as DateTimeContainer,
  Remaing,
  AuthorSubsection,
  Name,
  Email,
  Avatar,
  ContentUser,
  Total,
  Done,
  Pending,
  Late,
} from "./styles";

const AboutSection = ({
  flow,
  active,
  jobs,
  client,
  accountable,
  ganttStatus,
}) => {
  const [lastTaskDate, setLastTaskDate] = useState(null);

  function getLastTask(allTasks) {
    if (allTasks?.length > 0) {
      let aux = DateTime.fromJSDate(allTasks[0]?.end);
      let currentTask = allTasks[0];

      allTasks.forEach((item) => {
        const endDate = DateTime.fromJSDate(item.end);

        if (endDate > aux) {
          aux = endDate;
          currentTask = item;
        }
      });

      return DateTime.fromJSDate(new Date(String(currentTask.end)));
    } else return null;
  }

  useEffect(() => {
    if (ganttStatus === "done" && jobs?.length > 0) {
      setLastTaskDate(getLastTask(jobs));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ganttStatus]);

  const totalTasksInfo = jobs.reduce(
    (acc, item) => {
      if (item.type === "task") {
        acc.count++;
        acc.durationSum += item.duration.number;
      }
      return acc;
    },
    { count: 0, durationSum: 0 },
  );

  const doneTasksInfo = jobs.reduce(
    (acc, item) => {
      if (
        item.type === "task" &&
        (item.status === "done" || item.status === "doneLate")
      ) {
        acc.count++;
        acc.durationSum += item.duration.number;
      }
      return acc;
    },
    { count: 0, durationSum: 0 },
  );

  const doingTasks = jobs.reduce(
    (acc, item) =>
      item.type === "task" && item.status === "doing" ? ++acc : acc,
    0,
  );

  const lateTasks = jobs.reduce(
    (acc, item) =>
      item.type === "task" && item.status === "late" ? ++acc : acc,
    0,
  );

  const flowStatus =
    flow.status[0] === "finished"
      ? "Concluido"
      : flow.flowStatus.estimatedAt > flow.flowStatus.criticalDate
        ? "Atrasado"
        : "Em dia";

  const progress =
    flowStatus === "Concluido" ? 100 : flow.flowStatus.progress * 100;

  return (
    <Container active={active}>
      {active && (
        <>
          <Progression>
            <Status status={flowStatus}>{flowStatus}</Status>
            <ProgressionBar status={flowStatus}>
              <div
                style={{
                  width: `${progress}%`,
                }}
              />
              <span>{parseFloat(progress).toFixed(2) + "%"}</span>
            </ProgressionBar>
          </Progression>
          <Description>
            <span>Cliente: {flow.client}</span>
            <p>{flow.description}</p>
          </Description>
          <Prevision>
            <span
              style={{
                color: "#7e858f",
                fontSize: "0.70625rem",
                marginLeft: "0.889375rem",
              }}
            >
              Previsão de Término
            </span>
            <DateTimeContainer>
              {lastTaskDate ? (
                <>
                  <span>{lastTaskDate.toFormat("dd/MM/yyyy")}</span>
                  {flowStatus !== "Concluido" ? (
                    <Remaing>
                      Estimativa ~{" "}
                      {Math.ceil(
                        lastTaskDate.diff(DateTime.local(), "days").days,
                      )}{" "}
                      dias
                    </Remaing>
                  ) : (
                    <Remaing>Finalizado</Remaing>
                  )}
                </>
              ) : (
                <ReactLoading type="bars" color="#118052" />
              )}
            </DateTimeContainer>
          </Prevision>
          <Author>
            <span
              style={{
                fontWeight: 600,
                fontSize: "0.7062rem",
                color: "#212326",
              }}
            >
              Responsável
            </span>
            <AuthorSubsection>
              <Avatar src={accountable?.avatarURL} />
              <ContentUser>
                <Name>{accountable?.username}</Name>
                <Email>{accountable?.email}</Email>
              </ContentUser>
            </AuthorSubsection>
          </Author>
          <TasksManager>
            <span
              style={{
                fontSize: "0.7062rem",
                color: "#212326",
                fontWeight: 600,
              }}
            >
              Resumo de Tarefas
            </span>
            <div style={{ width: "100%", display: "flex" }}>
              <Total>
                <strong>{totalTasksInfo.count}</strong>
                <span>Total</span>
              </Total>
              <Done>
                <strong>{doneTasksInfo.count}</strong>
                <span>Concluídas</span>
              </Done>
            </div>
            <div style={{ width: "100%", display: "flex" }}>
              <Pending>
                <strong>{doingTasks}</strong>
                <span>Em execução</span>
              </Pending>
              <Late>
                <strong>{lateTasks}</strong>
                <span>Atrasados</span>
              </Late>
            </div>
          </TasksManager>
        </>
      )}
    </Container>
  );
};
export default AboutSection;
